export const sortByCoordinates = list =>
  list.sort((a, b) =>
    a.coordinates[0] > b.coordinates[0]
      ? 1
      : a.coordinates[0] === b.coordinates[0]
      ? a.coordinates[1] > b.coordinates[1]
        ? 1
        : -1
      : -1
  );
